import React from 'react';
import '../assets/css/menu.css'
import sSource from '../assets/images/imonfavicon.png';
import '../assets/images/1.jpg';
import '../assets/images/7.jpg';
const Menu = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar ftco-navbar-light p-0" id="ftco-navbar">
      <div className="container-fluid">
        <a className="navbar-brand" href="https://web.imonitorplus.com/">
          <img src={sSource} className="navbar-brand-logo " alt="logo" />iMonitor<sup>+</sup>
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="oi oi-menu"></span> Menu
        </button>

        <div className="collapse navbar-collapse" id="ftco-nav">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a href={"https://web.imonitorplus.com/"} className="nav-link">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a href={"https://web.imonitorplus.com/index.html#features_id"} className="nav-link">
                FEATURES
              </a>
            </li>
            <li className="nav-item">
              <a href={"https://web.imonitorplus.com/case_studies.html"} className="nav-link">
                CASE STUDIES
              </a>
            </li>
            <li className="nav-item">
              <a href={"https://web.imonitorplus.com/index.html#contact_us"} className="nav-link">
                Contact Us
              </a>
            </li>
            {/*<li className="nav-item cta">
              <a href="https://web.imonitorplus.com/dev_testing/#" className="nav-link" data-toggle="modal" data-target="#modalRequest">
                <span>Get a Quote</span>
              </a>
            </li>*/}
          </ul>
        </div>
      </div>
    </nav>
  )
};

export default Menu;